export default "/images/d44195b00f46d6842a143afd9da92747.avif";